import { CheckCircleBoldIcon, MicrosoftLoginIcon } from '@src/svg';
import { BASE_URL } from '@utils/constants';
import axios from 'axios';
import { loginRequest } from '@src/authConfig';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { logger } from '@utils/logger';
import React, { FC } from 'react';
import { toastError } from '@utils/helpers';
import { toastMessage } from '@utils/toastMessage';

type MicrosoftSignInButtonProps = {
  type?: 'attach' | 'basic';
  activated?: boolean;
};

export const MicrosoftSignInButton: FC<MicrosoftSignInButtonProps> = ({
  type = 'basic',
  activated = false,
}) => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  // TODO change this // move to RTK query!!
  const signInViaMicrosoft = async () => {
    const loginResponse = await instance.loginPopup(loginRequest);

    instance.setActiveAccount(loginResponse.account);

    logger.log(loginResponse.account, 'asdasd');
    axios
      .post(
        `${BASE_URL}/auth/microsoft/login`,
        // { email: loginResponse.account.username },
        { idToken: loginResponse.account.idToken },
        { withCredentials: true }
      )
      .then(() => {
        navigate('/');
      })
      .catch((error) => {
        logger.log('error', error);
        toastError(error, toastMessage.AUTH.noAccountLinkedToMicrosoft);
        navigate('/authorization/login');
      });
    logger.log('User logged in and backend session created');
  };

  return (
    <button
      className="social_button"
      type="button"
      onClick={signInViaMicrosoft}
      disabled={activated && type !== 'basic'}
    >
      <MicrosoftLoginIcon />
      {type !== 'attach'
        ? ''
        : activated
          ? 'Microsoft SSO Activated'
          : 'Setup Microsoft SSO'}
      {type === 'basic' && 'Sign in with Microsoft'}
      {activated && type !== 'basic' && (
        <span className="sso-activated-icon">
          <CheckCircleBoldIcon width={24} height={24} />
        </span>
      )}
    </button>
  );
};
